let lab = {
    $close: $('#js-labClose'),
    $download: $('#js-labDownload'),
    $exifData: $('#js-labExifData'),
    $exifMap: $('#js-labExifMap'),
    $exifMapCanvas: $('#js-labExifMapCanvas'),
    $lab: $('#js-lab'),
    $photo: $('#js-labPhoto'),
    $rotate: $('#js-labRotate'),
    $toggleBrightness: $('#js-labToggleBrightness'),
    $toggleExif: $('#js-labToggleExif'),
    $zoomIn: $('#js-labZoomIn'),
    $zoomOut: $('#js-labZoomOut'),
    classNameActive: 'is-lab',
    classNameButtonActive: 'is-active',
    classNameButtonDisabled: 'is-disabled',
    classNamePhotoBrightened: 'is-brightened',
    classNamePhotoDragging: 'is-dragging',
    classNamePhotoLoaded: 'is-loaded',
    classNameShowExif: 'show-exif',
    classNameTrigger: 'js-lab',
    dragging: false,
    dragStartX: 0,
    dragStartY: 0,
    exif: null,
    exifTemplate: _.template($('#js-labExifDataTemplate').html()),
    isActive: false,
    map: null,
    padding: 12,
    photo: {},
    rotation: 0,
    zoomCurrentIndex: 3,
    zoomDefaultIndex: 3,
    zoomOptions: [ 0.25, 0.5, 0.75, 1, 1.5, 2, 3, 4, 5 ],

    close() {
        $('body').removeClass(this.classNameActive)
        this.isActive = false
        this.reset()
    },

    init() {
        $(`.${this.classNameTrigger}`).on('click', this.onOpen.bind(this))
        this.$close.on('click', this.onClose.bind(this))
        this.initDragging()
        this.initToolbar()

        window.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && this.isActive) {
                this.close()
            }
        }, false)
    },

    getScreenX: function (e) {
        if (e.touches && e.touches.length) {
            return e.touches[0].screenX
        }

        return e.screenX
    },

    getScreenY: function (e) {
        if (e.touches && e.touches.length) {
            return e.touches[0].screenY
        }

        return e.screenY
    },

    setDragging(dragging) {
        this.$photo[dragging ? 'addClass' : 'removeClass'](this.classNamePhotoDragging)
        this.dragging = dragging
    },

    initDragging: function () {
        this.$photo.on('mousedown touchstart', (e) => {
            this.setDragging(true)
            this.dragStartX = this.getScreenX(e)
            this.dragStartY = this.getScreenY(e)

            $(window).one('mouseup touchend', (e) => {
                this.setDragging(false)
                this.photo.left = parseInt(this.$photo.css('left'))
                this.photo.top = parseInt(this.$photo.css('top'))
            })
        })

        $(window).on('mousemove touchmove', (e) => {
            if (this.dragging) {
                this.$photo.css({
                    left: this.photo.left + (this.getScreenX(e) - this.dragStartX),
                    top: this.photo.top + (this.getScreenY(e) - this.dragStartY)
                })
            }
        })
    },

    initExif() {
        fetch(`/foto/${this.photo.token}/exif-panel`)
            .then(response => response.json())
            .then(json => {
                // Load EXIF data table
                const $exif = $(this.exifTemplate({ exif: json, token: this.photo.token }))
                this.$exifData.html($exif)
            })
    },

    initToolbar() {
        this.$download.on('click', this.onDownload.bind(this))
        this.$rotate.on('click', this.onRotate.bind(this))
        this.$toggleBrightness.on('click', this.onToggleBrightness.bind(this))
        this.$toggleExif.on('click', this.onToggleExif.bind(this))
        this.$zoomIn.on('click', this.onZoomIn.bind(this))
        this.$zoomOut.on('click', this.onZoomOut.bind(this))
    },

    onClose(e) {
        e.preventDefault()
        this.close()
    },

    onDownload(e) {
        e.preventDefault()
        window.location.href = this.photo.download
    },

    onLoad(e) {
        this.$lab.addClass(this.classNamePhotoLoaded)
        this.$photo.css('background-image', `url('${this.photo.src}')`)
        this.initExif()
    },

    onOpen(e) {
        const $el = $(e.currentTarget)

        this.photo = {
            download: $el.attr('data-photo-download'),
            src: $el.attr('data-photo-src'),
            token: $el.attr('data-photo-token'),
        }

        // Show lab
        $('body').addClass(this.classNameActive)
        this.isActive = true

        // Load photo
        const img = new Image()
        img.onload = this.onLoad.bind(this)
        img.src = this.photo.src

        e.preventDefault()
    },

    onRotate(e) {
        e.preventDefault()
        this.rotation -= 90
        this.updateTransform()
    },

    onToggleBrightness(e) {
        e.preventDefault()
        $(e.currentTarget).toggleClass(this.classNameButtonActive)
        this.$photo.toggleClass(this.classNamePhotoBrightened)
    },

    onToggleExif(e) {
        e.preventDefault()
        $(e.currentTarget).toggleClass(this.classNameButtonActive)
        this.$lab.toggleClass(this.classNameShowExif)
    },

    onZoomIn(e) {
        e.preventDefault()
        this.zoom(1)
    },

    onZoomOut(e) {
        e.preventDefault()
        this.zoom(-1)
    },

    reset() {
        this.$lab.removeClass(this.classNameShowExif)
        this.$photo.removeClass(this.classNamePhotoBrightened)
        this.$photo.removeClass(this.classNamePhotoLoaded)
        this.$toggleBrightness.removeClass(this.classNameButtonActive)
        this.$toggleExif.removeClass(this.classNameButtonActive)

        this.rotation = 0
        this.zoomCurrentIndex = this.zoomDefaultIndex
    },

    updateTransform() {
        let zoom

        zoom = this.zoomOptions[this.zoomCurrentIndex]

        this.$photo.css({
            '-webkit-transform': `rotate(${this.rotation}deg) scale(${zoom})`,
               '-moz-transform': `rotate(${this.rotation}deg) scale(${zoom})`,
                '-ms-transform': `rotate(${this.rotation}deg) scale(${zoom})`,
                    'transform': `rotate(${this.rotation}deg) scale(${zoom})`
        })
    },

    updateZoomButtons() {
        this.$zoomIn.removeClass(this.classNameButtonDisabled)
        this.$zoomOut.removeClass(this.classNameButtonDisabled)

        if (this.zoomCurrentIndex === 0) {
            this.$zoomOut.addClass(this.classNameButtonDisabled)
        }

        if (this.zoomCurrentIndex === (this.zoomOptions.length - 1)) {
            this.$zoomIn.addClass(this.classNameButtonDisabled)
        }
    },

    zoom(direction) {
        // Set new zoom level
        this.zoomCurrentIndex += direction

        if (this.zoomCurrentIndex < 0 && this.zoomCurrentIndex == this.zoomOptions.length) {
            // Whoops, out of range. Undo.
            this.zoomCurrentIndex -= direction
        }

        this.updateTransform()
        this.updateZoomButtons()
    }
}

export default lab